import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, UserGroup, UserService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

/**
 * Generic MySQL-group multi-select modal. Reused across community-detail (moderator roles,
 * admin roles, required groups). Callers pass in the currently-selected group names and a
 * `groups` list; the modal emits the new list on Save. Works on a local working copy so
 * Cancel discards changes.
 *
 * DENG-728 Phase 4 UX polish — replaces the inline scrolling checkbox lists.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-select-groups",
  templateUrl: "select-groups.component.html",
  standalone: false,
})
export class SelectGroupsComponent extends BaseComponent implements OnInit {
  @Input() title = "Select Groups";
  @Input() description: string | null = null;
  @Input() groups: UserGroup[] = [];
  @Input() selectedNames: string[] = [];
  @Output() groupsSelected: EventEmitter<string[]> = new EventEmitter();

  public workingMap: Record<string, boolean> = {};
  public query = "";

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal
  ) {
    super(userService);
  }

  ngOnInit() {
    // Working copy so Cancel truly discards. Owner won't see changes until Save.
    this.selectedNames.forEach((name) => (this.workingMap[name] = true));
  }

  get filteredGroups(): UserGroup[] {
    const q = (this.query || "").trim().toLowerCase();
    if (!q) return this.groups;
    return this.groups.filter((g) => g.name.toLowerCase().includes(q) || (g.description || "").toLowerCase().includes(q));
  }

  toggle(name: string) {
    this.workingMap[name] = !this.workingMap[name];
  }

  save() {
    const selected = Object.keys(this.workingMap).filter((k) => this.workingMap[k]);
    this.groupsSelected.next(selected);
    this.activeModal.close();
  }
}
